// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"ICDGroup_tableWrap__24DKv"};